export default function CommunityGuidelines() {
  return (
    <div className='legal-doc-body'>

      <p>
        These Community Guidelines govern how members of MJMarry interact with one another and use our platform. 
        By using MJMarry, you agree to uphold these standards, which are designed to maintain a respectful, safe, 
        and Islamic-values-centred environment for all users seeking a halal marriage partner.
      </p>

      <div className='privacy terms cookies'>

        <h1>1. Our Community Values</h1>
        <p>
          MJMarry is a platform built on Islamic principles, mutual respect, and the sincere pursuit of marriage. 
          Every member is expected to engage with honesty, decency, and a genuine intention to find a compatible 
          life partner in accordance with Islamic guidelines.
        </p>
        <p>
          We strive to provide a community where users feel safe, respected, and free from harassment, discrimination, 
          or any form of misconduct. These guidelines help us maintain that environment for everyone.
        </p>

        <h1>2. Respectful Communication</h1>
        <p>
          All communication on MJMarry — whether in messages, profile content, or any other interaction — must be 
          respectful, courteous, and appropriate. We have zero tolerance for abusive, offensive, or degrading language 
          of any kind.
        </p>

        <h2>2.1 Prohibited Language and Content</h2>
        <p>
          The following types of communication are strictly prohibited on MJMarry:
        </p>
        <ul>
          <li>Hate speech, slurs, or discriminatory language based on race, ethnicity, nationality, gender, disability, or any other characteristic.</li>
          <li>Threats, intimidation, or harassment of any user.</li>
          <li>Sexually explicit, vulgar, or inappropriate content.</li>
          <li>Spam, unsolicited advertising, or repetitive messaging.</li>
          <li>Content that promotes or glorifies violence, extremism, or illegal activities.</li>
        </ul>

        <h2>2.2 Islamic Etiquette</h2>
        <p>
          We encourage all users to communicate with the Islamic etiquette (adab) befitting individuals seeking a 
          righteous marriage. This includes kindness, patience, and the avoidance of any language or behaviour 
          that could be considered contrary to Islamic moral standards.
        </p>

        <h1>3. Honest and Accurate Profiles</h1>
        <p>
          Authenticity is essential to building trust and facilitating meaningful connections on MJMarry. 
          All users must represent themselves honestly in their profiles.
        </p>

        <h2>3.1 Profile Information</h2>
        <p>
          You must provide accurate information about yourself, including your name, age, location, and any other 
          details you choose to share. Misrepresenting your identity or providing false information is a serious 
          violation of our guidelines and may result in account suspension or removal.
        </p>

        <h2>3.2 Profile Photos</h2>
        <p>
          Profile photos must be genuine, recent images of yourself. Using photos of other people, celebrities, 
          or images that misrepresent your appearance is strictly prohibited. All photos must be modest and 
          appropriate in accordance with Islamic values.
        </p>

        <h2>3.3 Catfishing and Impersonation</h2>
        <p>
          Impersonating another person, whether a real individual or a fictional character, is not permitted. 
          Creating fake profiles to deceive other users or to gain access to information under false pretences 
          is a serious breach of our guidelines.
        </p>

        <h1>4. Appropriate Conduct</h1>
        <p>
          MJMarry is a marriage platform, and all interactions should reflect the seriousness and sanctity 
          of that purpose. Behaviour that undermines the integrity of the platform or causes harm to other 
          users will not be tolerated.
        </p>

        <h2>4.1 Harassment and Unwanted Contact</h2>
        <p>
          If a user has not responded to your messages or has indicated they are not interested, please respect 
          their decision and refrain from further contact. Persistent or unwanted messaging constitutes harassment 
          and is grounds for account action.
        </p>

        <h2>4.2 Scams and Fraudulent Activity</h2>
        <p>
          Any attempt to defraud, manipulate, or financially exploit other users is strictly prohibited. This 
          includes requesting money, sharing suspicious links, or engaging in any form of romance scam. 
          We encourage users to report any suspicious activity immediately.
        </p>

        <h2>4.3 Off-Platform Solicitation</h2>
        <p>
          Using MJMarry to promote external services, businesses, or to redirect users to other platforms for 
          commercial purposes without authorisation is not permitted.
        </p>

        <h1>5. Safety and Privacy</h1>
        <p>
          Your safety and privacy are our highest priorities. MJMarry provides tools to help you manage your 
          experience, including reporting, blocking, and privacy settings. We strongly encourage all users to 
          take advantage of these features.
        </p>

        <h2>5.1 Personal Information</h2>
        <p>
          Do not share sensitive personal information — such as your home address, financial details, or 
          national identification numbers — with other users, especially before establishing a level of 
          trust. Exercise caution when deciding how much personal information to disclose.
        </p>

        <h2>5.2 Protecting Others' Privacy</h2>
        <p>
          You must not share, distribute, or publish personal information about other users without their 
          explicit consent. This includes screenshots of private conversations, photos, or any other content 
          shared in confidence.
        </p>

        <h2>5.3 Minors</h2>
        <p>
          MJMarry is strictly for adults aged 18 and above. If you encounter a profile that appears to belong 
          to a minor, please report it immediately. We take the protection of minors extremely seriously and 
          will act swiftly on all such reports.
        </p>

        <h1>6. Reporting Violations</h1>
        <p>
          If you encounter behaviour, content, or profiles that violate these Community Guidelines, we urge 
          you to use our in-app reporting tools. Your reports help us maintain the integrity and safety of 
          our community. All reports are reviewed confidentially by our moderation team.
        </p>
        <p>
          Reports can be submitted directly from a user's profile or message thread. For urgent safety 
          concerns, please also contact us at <strong>support@mjmarry.com</strong>.
        </p>

        <h1>7. Consequences of Violations</h1>
        <p>
          Violations of these Community Guidelines may result in a range of actions depending on the 
          severity and frequency of the breach, including but not limited to:
        </p>
        <ul>
          <li>A formal warning issued to the user's account.</li>
          <li>Temporary suspension of account functionality.</li>
          <li>Permanent removal of the account from the platform.</li>
          <li>Referral to relevant law enforcement authorities where illegal activity is identified.</li>
        </ul>
        <p>
          MJMarry reserves the right to take any action it deems appropriate to protect our users and 
          uphold the values of our community, at its sole discretion.
        </p>

        <h1>8. Updates to These Guidelines</h1>
        <p>
          We may update these Community Guidelines from time to time to reflect changes in our platform, 
          community needs, or applicable laws. When we make significant changes, we will notify users 
          through the platform or via email. Continued use of MJMarry after such updates constitutes 
          your acceptance of the revised guidelines.
        </p>
        <p>
          We encourage you to review these guidelines periodically to stay informed about the standards 
          that govern our community.
        </p>

        <h1>9. Contact Us</h1>
        <p>
          If you have any questions, concerns, or feedback regarding these Community Guidelines, please 
          do not hesitate to reach out to our team:
        </p>
        <p>
          <strong>Email:</strong> support@mjmarry.com<br />
          <strong>Website:</strong> www.mjmarry.com
        </p>

      </div>
    </div>
  );
}
